import React from 'react';

const PliseSettings = React.memo(({
  pliseExtras,
  setPliseExtras
}) => (
  <div className="settings-card">
    <div className="settings-card-title">
      <i className="fas fa-tools"></i>
      <h4>Üretim Montaj Seçenekleri Ek Ücret Ayarları (₺)</h4>
    </div>
    <div className="settings-grid">
      <div className="form-group">
        <label>Portraylı Montaj</label>
        <input
          type="number"
          value={pliseExtras.portrayliMontaj}
          onChange={(e) => setPliseExtras((p) => ({ ...p, portrayliMontaj: e.target.value }))}
        />
      </div>
      <div className="form-group">
        <label>Yapıştırma Sistem</label>
        <input
          type="number"
          value={pliseExtras.yapistirmaSistem}
          onChange={(e) => setPliseExtras((p) => ({ ...p, yapistirmaSistem: e.target.value }))}
        />
      </div>
      <div className="form-group">
        <label>Isıcamlı Yapıştırma</label>
        <input
          type="number"
          value={pliseExtras.isicamliYapistirma}
          onChange={(e) => setPliseExtras((p) => ({ ...p, isicamliYapistirma: e.target.value }))}
        />
      </div>
    </div>
  </div>
));

export default PliseSettings;
